import { Injectable } from '@angular/core';
import { Toast } from './models/Toast';

@Injectable({
  providedIn: 'root'
})
export class ToasterService {

  constructor() { }

  toasts: Toast[] = [];

  defaultDelay: number = 5000;
  defaultClasses: string[] = ['bg-success', 'text-light'];

  show(toast: Toast) {
    this.toasts.push(toast);
  }

  showDefault(text: string) {
    this.show({
      text: text,
      delay: this.defaultDelay,
      classname: this.defaultClasses.join(' ')
    })
  }

  showDanger(text: string, overrideAllMessages: boolean = false) {
    if (overrideAllMessages) {
      this.clear();
    }
    this.show({
      text: text,
      delay: this.defaultDelay,
      classname: 'bg-danger  text-light'
    })
  }

  remove(toast: Toast) {
    this.toasts = this.toasts.filter((t) => t !== toast);
  }

  clear() {
    this.toasts.splice(0, this.toasts.length);
  }
}
